import axios, { AxiosError } from "axios";
import { BASE_HEADLESS } from "./headless";
const PUBLIC_URL = BASE_HEADLESS;
const AUTH = "Bearer 3b0ec705-120d-4918-8319-75f196991477";

const createEventRequest = async (
  userId: string,
  answers: any,
  conversation?: string
) => {
  console.debug(conversation);
  console.debug(answers);

  const _convId = conversation ?? answers["conversation"];
  if (!_convId) {
    throw new Error("No conversation selected");
  }
  const response = await axios.post(`${PUBLIC_URL}/api/user/event/`, {
    conversation: _convId,
    userId,
    answers,
  });
  const result = {
    msg: response.data.msg,
    eventId: response.data.eventId,
  };
  if (!result.eventId) {
    throw new Error(result.msg);
  }
  return response.data.eventId as string;
};

const getLatestsUndoneEvents = async (userId: string) => {
  try {
    const response = await axios.get(`${PUBLIC_URL}/api/user/event/${userId}`);
    const result = {
      msg: response.data.msg,
      status: response.data.event.nextSlot.status ?? "IDLE",
      event: {
        eventId: response.data.event.eventId,
        nextSlot: response.data.event.nextSlot,
      },
    };

    if (!result.event.nextSlot || !result.event.eventId) {
      throw new Error(result.msg);
    }
    return result;
  } catch (error) {
    if ((error as AxiosError).isAxiosError) {
      const axiosError = error as AxiosError;
      if (axiosError.code === "404") return null;
    }
  }
};

const addFeedBack = async (
  url: string,
  event_id: string,
  feedback: number,
  freeTexttext: string,
  question: string
) => {
  const response = await axios.post(
    `${url}/feedback`,
    {
      score: feedback,
      eventId: event_id,
      timestemp: Date.now(), // keeping the old with typo for old Webapp's
      timestamp: Date.now(),
      question: question,
      answer: freeTexttext,
    },
    {
      headers: {
        Authorization: AUTH,
      },
    }
  );
  return response;
};

export { createEventRequest, getLatestsUndoneEvents, addFeedBack };
